module.exports = __webpack_public_path__ + "static/media/confirmacion1.490f3cc4.svg";